import { Divider, Flex, Loader, Text } from "@fluentui/react-northstar";
import { Card, Col, Row, Select } from "antd";
import React, { useEffect, useState } from "react";
import Layout from "../../Layout/Layout";
import { api } from "../../../../Assets/api/api";
import GradeDistribution from "./components/KeyMetrics/GradeDistribution";
import AiOverwrite from "./components/KeyMetrics/AiOverwrite";
import GradingTime from "./components/KeyMetrics/GradingTime";
import PersonalizedFeedback from "./components/KeyMetrics/PersonalizedFeedback";
import RubricCriteriaPerformance from "./components/RubricCriteriaPerformance";
import RubricPerformance from "./components/RubricPerformance";
import "./AssignmentSpecialReport.scss";

function AssignmentSpecialReport(props) {
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 767);
  const [analytics, setAnalytics] = useState([]);
  const [selectedAnalytics, setSelectedAnalytics] = useState(null);
  const [lessons, setLessons] = useState([]);
  const [selectedLesson, setselectedLesson] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const fetchLAssignmentAnalyticsBy = async () => {
    try {
      setIsLoading(true);
      const res = await api.get(
        `/api/assignment/get-lesson-wise-assignment-analytics${props.user.slug}`
      );
      const analytics = res.data.results;
      setAnalytics(analytics);
      setSelectedAnalytics(analytics[0]);
      const lessons = res.data.results.map((lesson, i) => ({
        key: i + 1,
        lable: lesson.lessonInfo.ClassName,
        value: lesson.lessonInfo.ClassName,
      }));
      setLessons(lessons);
      setselectedLesson(lessons[0].value);
    } catch (error) {
      console.log("fetchLAssignmentAnalyticsBy", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchLAssignmentAnalyticsBy();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 767);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const keyMetrics = selectedAnalytics?.analytics?.keyMetrics;

  return (
    <div className="assignment-special-report-wrapper">
      <Layout isReportAvailable={true} isMobileView={isMobileView}>
        <Divider />
        {isLoading ? (
          <Flex hAlign="center" style={{ marginTop: 200 }}>
            <Loader />
          </Flex>
        ) : (
          selectedAnalytics && (
            <Card
              title={selectedLesson.value}
              style={{ marginBottom: "20px", borderRadius: "8px" }}
              extra={
                <Select
                  value={selectedLesson}
                  style={{ width: 240 }}
                  loading={isLoading}
                  options={lessons}
                  placeholder="Select Lesson"
                  onSelect={(value) => {
                    const selectedAnalytics = analytics.find(
                      (analytic) => analytic.className === value
                    );

                    setselectedLesson(value);
                    setSelectedAnalytics(selectedAnalytics);
                  }}
                />
              }
              className="shadow"
            >
              <Row gutter={[15, 15]}>
                <Col xs={24} md={6}>
                  <GradeDistribution
                    distribution={keyMetrics?.gradeDistribution}
                  />
                </Col>
                <Col xs={24} md={6}>
                  <AiOverwrite aiOverrideRate={keyMetrics?.aiOverrideRate} />
                </Col>
                <Col xs={24} md={6}>
                  <GradingTime gradingTime={keyMetrics?.gradingTime} />
                </Col>
                <Col xs={24} md={6}>
                  <PersonalizedFeedback
                    personalizedFeedback={keyMetrics?.personalizedFeedback}
                  />
                </Col>
                <Col xs={24} md={12}>
                  <RubricCriteriaPerformance
                    rubricPerformance={
                      selectedAnalytics.analytics.rubricPerformance
                    }
                  />
                </Col>
                <Col xs={24} md={12}>
                  <RubricPerformance
                    rubricPerformance={
                      selectedAnalytics.analytics.rubricPerformance
                    }
                  />
                </Col>
              </Row>
            </Card>
          )
        )}
      </Layout>
    </div>
  );
}

export default AssignmentSpecialReport;
